import { string } from 'prop-types';
import React, { useMemo } from 'react';
import { Badge } from 'react-bootstrap';

const SUCCESS_STATUS = 'SUCCESS';
const PENDING_STATUS = 'PENDING';
const FAILURE_STATUS = 'FAILURE';

function TransactionStatusBadge({ status }) {
    const statusBadgeType = useMemo(() => {
        if (status === PENDING_STATUS) {
            return 'warning';
        } else if (status === SUCCESS_STATUS) {
            return 'success';
        } else if (status === FAILURE_STATUS) {
            return 'danger';
        } else {
            return 'dark';
        }
    }, [status]);
    
    return (
        <Badge
            bg={statusBadgeType}
        >
            {status}
        </Badge>
    );
}

TransactionStatusBadge.propTypes = {
    status: string,
};

export default TransactionStatusBadge;